export default function SET_CURATORS(state, payload) {
  state.curators = payload.origin.curators;
}
